export const validationMessages = {
    ru: {
        EMPTY_FIELD: 'Поле обязательно к заполнению',
        INVALIDATED_EMAIL: 'Введите корректный адрес эл. почты',
        INVALIDATED_PHONE: 'Введите корректный номер телефона',
        INVALIDATED_SELECT: 'Выберите значение из списка',
        INVALIDATED_FILE: 'Загрузите файл',
        INVALIDATED_FILE_TYPE: 'Недопустимый формат файла. Допустимые: {formats}',
        INVALIDATED_EQUALS: 'Значение полей должно совпадать',
    },
    en: {
        EMPTY_FIELD: 'This field must not be empty',
        INVALIDATED_EMAIL: 'Enter a valid email address',
        INVALIDATED_PHONE: 'Enter a valid phone number',
        INVALIDATED_SELECT: 'Choose an option',
        INVALIDATED_FILE: 'Upload a file',
        INVALIDATED_FILE_TYPE: 'Invalid file format. Allowed: {formats}',
        INVALIDATED_EQUALS: 'Values must be equal',
    },
};
